import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Form,
  Divider,
  Input,
  Select,
  Modal,
  Button,
  Drawer,
  Table,
  Space,
  Radio,
} from "antd";
import getFormItemRules from "../../shared/form-helper";
import TestCampaign from "../test-campaign";
import API from "../../utils/Api";
import { range, isEmpty, flatten, uniqBy } from "lodash";
import { EyeOutlined, WalletOutlined } from "@ant-design/icons";
import Handlebars from "handlebars";

const { Option } = Select;

const WhatsappCampaign = (properties) => {
  const {
    form,
    next,
    selectCampaign,
    getExpressionCount,
    whatsappTemplateData,
    loading,
    users,
    templateExpressionCount,
    dupTemplateObj,
    setDupTemplateObj,
    dupWtTemp,
    setDupWtTemp,
    broadCast,
    costing,
    onFinish,
    walletBalance,
    walletBalanceError,
    handleSelectedUser,
  } = properties;
  const myApi = new API({});
  myApi.createEntity({ name: "testapi" });
  const [selectTemplate, setSelectTemplate] = useState("");
  const [isModalOpen, setOpen] = useState(false);
  const [templateContent, setTemplateContent] = useState(dupWtTemp);
  const [templateObj] = useState(dupTemplateObj);
  const [templateObjDecode] = useState(dupTemplateObj);
  const [selectedUser, setSelectedUser] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [templateLength, setTemplateLength] = useState(0);
  const filterUserBy = form.getFieldValue("filterUserBy");
  const selectBroadCast = form.getFieldValue("boardCast");
  const campaignTags = form.getFieldValue("campaign_tags");

  const columns = [
    {
      title: "Name",
      dataIndex: "user_name",
    },
    {
      title: "Mobile Number",
      dataIndex: "phone_number",
    },

    {
      title: "City",
      dataIndex: "city",
    },
  ];

  const handleSelectTemplate = (value) => {
    setSelectTemplate(value);
    const filteredWhatsAppTemplate = whatsappTemplateData.filter(
      (item) => item.template_name === value
    );
    if (filteredWhatsAppTemplate) {
      const { whatsapp_content: whatsappContent } =
        filteredWhatsAppTemplate && filteredWhatsAppTemplate[0];
      const count = (whatsappContent.match(/{{\$[0-9]}}/g) || []).length;
      getExpressionCount(count);
      setTemplateContent(whatsappContent);
      setDupWtTemp(whatsappContent);
      setTemplateLength(whatsappContent.length);
      form.setFieldsValue({
        whatsapp_content: whatsappContent,
      });
    }
  };

  useEffect(() => {
    if (campaignTags === "all_users") {
      setSelectedUser(users);
      handleSelectedUser(users);
    } else if (campaignTags === "board_cast") {
      const filterData = broadCast.filter((data) =>
        selectBroadCast.includes(data.board_cast_uid)
      );
      const getUsers = filterData.map((item) => item.user_list);
      const flattenUsers = flatten(getUsers);
      const uniqByMobile = uniqBy(flattenUsers, "phone_number");
      setSelectedUser(uniqByMobile);
      handleSelectedUser(uniqByMobile);
    } else {
      const filterData = users.filter((data) =>
        filterUserBy.includes(data.phone_number)
      );
      setSelectedUser(filterData);
      handleSelectedUser(filterData);
    }
    const whatsappContent = form.getFieldValue("whatsapp_content");
    const whatsappTemplate = form.getFieldValue("whatsappTemplate");
    if (whatsappContent || whatsappTemplate) {
      setTemplateLength(whatsappContent.length || 0);
      handleSelectTemplate(whatsappTemplate);
      if (templateExpressionCount) {
        range(templateExpressionCount).map((index) => {
          form.resetFields([`Content${index + 1}`]);
        });
      }
    }
    form.setFieldsValue({
      payment_type: "Wallet",
    });
  }, [campaignTags, filterUserBy, users]);

  useEffect(() => {
    if (!isEmpty(dupTemplateObj)) {
      Object.keys(dupTemplateObj).map((item, index) => {
        form.setFieldsValue({
          [`Content${index + 1}`]: dupTemplateObj[item],
        });
      });
      handleTemplate();
    }
  }, []);

  const handleTemplate = () => {
    const WtMessage = Handlebars.compile(templateContent)(templateObjDecode);
    setTemplateLength(WtMessage.length);
    form.setFieldsValue({
      whatsapp_content: WtMessage,
    });
  };

  const handleContent = (event, id) => {
    const { value } = event.target;
    if (templateObj.hasOwnProperty(id)) {
      templateObj = encodeURIComponent(value);
      templateObjDecode = value;
      setDupTemplateObj(templateObj);
      handleTemplate();
    } else {
      templateObj[`$${id}`] = encodeURIComponent(value);
      templateObjDecode[`$${id}`] = value;
      setDupTemplateObj(templateObj);
      handleTemplate();
    }
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const handleCancel = () => {
    setOpen(false);
    setOpenDrawer(false);
  };
  const handleOpenDrawer = () => {
    setOpenDrawer(true);
  };
  return (
    <>
      <Divider />
      <div>
        <Row>
          <h4>Choose Template</h4>
        </Row>
        <Row className="mt-10">
          <Col span={6}>
            <Form.Item name="whatsappTemplate">
              <Select
                placeholder="Select a Template"
                value={selectTemplate}
                onChange={handleSelectTemplate}
                loading={loading}
                disabled={loading}
                size="large"
              >
                {whatsappTemplateData &&
                  whatsappTemplateData.map((item) => (
                    <Option key={item.template_name} value={item.template_name}>
                      {item.template_name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        {selectTemplate && (
          <>
            <Row>
              <Col className="" span={16}>
                <Form.Item label="Template Content" name="whatsapp_content">
                  <Input.TextArea
                    className="template-textarea"
                    disabled
                    autoSize
                    maxLength={1024}
                  />
                </Form.Item>
                <span className="characters">
                  Characters : {templateLength} /1024{" "}
                </span>
              </Col>
            </Row>
            <Row>
              {templateExpressionCount &&
                range(templateExpressionCount).map((index) => {
                  return (
                    <Col span={5} className="ml-2">
                      <Form.Item
                        label={`Enter Content for {{${index + 1}}} `}
                        name={`Content${index + 1}`}
                        rules={[
                          ...getFormItemRules({
                            required: true,
                            message: `Please enter Content${index + 1} value`,
                          }),
                        ]}
                      >
                        <Input
                          placeholder={`Enter Content for {{${index + 1}}} `}
                          onChange={(event) => handleContent(event, index + 1)}
                          size="large"
                        />
                      </Form.Item>
                    </Col>
                  );
                })}
            </Row>
            <Divider />
            <Row>
              <h4>Summary</h4>
            </Row>
            <Row className="ml-10">
              <Col span={6}>
                <p>No of Customers</p>
              </Col>
              <Col span={8}>
                <p>{selectedUser.length || 0}</p>
              </Col>
              <Col span={6}>
                <Row>
                  <EyeOutlined
                    style={{ color: "rgb(12, 99, 99)" }}
                    onClick={() => handleOpenDrawer()}
                  />
                  <p className="view-p">View Customer List</p>
                </Row>
              </Col>
            </Row>
            <Row className="ml-10">
              <Col span={6}>
                <p>Template Selected</p>
              </Col>
              <Col span={8}>
                <p>{selectTemplate || "Template"}</p>
              </Col>
              <Col span={6}>
                <Row>
                  <EyeOutlined
                    style={{ color: "rgb(12, 99, 99)" }}
                    onClick={() => handleOpen()}
                  />
                  <p className="view-p">View Template</p>{" "}
                </Row>
              </Col>
            </Row>
            {Number(costing) ? (
              <>
                <Divider />
                <Row className="justify-bt">
                  <p>BroadCast Charges</p>
                  <p>{`1 message cost = ${Number(costing || 0)} rupees`} </p>
                  <p>{`${Number(selectedUser.length || 0)} × ${Number(
                    costing || 0
                  )}`}</p>
                </Row>
                <Row className="justify-bt">
                  <p>Total Charges</p>
                  <h4>{`₹ ${parseFloat(
                    Number(selectedUser.length || 0) * Number(costing || 0)
                  ).toFixed(2)}`}</h4>
                </Row>
                <Divider />
                <div>
                  <h3>Select Payment Method</h3>
                  <Row className="justify-bt">
                    <div>
                      <Form.Item
                        name="payment_type"
                        rules={[
                          ...getFormItemRules({
                            required: true,
                          }),
                        ]}
                      >
                        <Radio.Group
                          style={{ marginRight: "10px" }}
                          name="payment_type"
                        >
                          <Radio value="Wallet">
                            <Space>
                              <WalletOutlined />
                              Wallet
                            </Space>
                          </Radio>
                        </Radio.Group>
                      </Form.Item>

                      {!isEmpty(walletBalanceError) ? (
                        <span className="p-red">
                          <p>{`Balance :₹ ${
                            Number(parseFloat(walletBalance).toFixed(2)) || 0
                          }`}</p>
                          <p>
                            {`*Low Balance. Please Recharge your wallet and try.*`}{" "}
                          </p>
                        </span>
                      ) : (
                        <p>
                          {`Balance :₹ ${
                            Number(parseFloat(walletBalance).toFixed(2)) || 0
                          }`}
                        </p>
                      )}
                    </div>
                    <div>
                      <Button
                        disabled={!isEmpty(walletBalanceError)}
                        type="primary"
                        onClick={() => onFinish()}
                      >
                        {Number(costing)
                          ? `Pay : ₹ ${parseFloat(
                              Number(selectedUser.length || 0) * Number(costing)
                            ).toFixed(2)} & Publish`
                          : `Publish`}
                      </Button>
                    </div>
                  </Row>
                </div>
              </>
            ) : null}
            <Divider />
            <TestCampaign
              form={form}
              next={next}
              selectCampaign={selectCampaign}
              templateObj={templateObj}
              templateExpressionCount={templateExpressionCount}
              costing={costing}
            />
          </>
        )}
      </div>

      <Divider />
      {isModalOpen && (
        <Modal
          title="Template Content"
          visible={isModalOpen}
          footer={null}
          onCancel={handleCancel}
          width={600}
        >
          <Form.Item name="whatsapp_content">
            <Input.TextArea
              className="template-textarea"
              disabled
              autoSize
              maxLength={1024}
            />
          </Form.Item>
        </Modal>
      )}
      {openDrawer && (
        <Drawer
          title="User List"
          placement="right"
          onClose={handleCancel}
          visible={openDrawer}
          width={720}
        >
          <Table
            className="grid-table"
            columns={columns}
            dataSource={selectedUser}
          />
        </Drawer>
      )}
    </>
  );
};

export default WhatsappCampaign;
